import { PureComponent } from 'react';
import PropTypes from 'prop-types';
const SEAT_TYPES = ['busy', 'free', 'recently-selected'];
export default class Seat extends PureComponent {
  static propTypes = {
    isSelected: PropTypes.bool.isRequired,
    onSelectedChange: PropTypes.func.isRequired,
    id: PropTypes.string,
    number: PropTypes.string,
    type: PropTypes.string
  };
  onClick = () => {
    const {
      id,
      number,
      isSelected
    } = this.props;
    this.props.onSelectedChange({
      id,
      number,
      isSelected: !isSelected
    });
  };
  getClassName = type => {
    let className = 'ticket__place-item';
    switch (type) {
      case 'free':
        className += ' enabled';
        break;
      case 'recently-selected':
        className += ' recently-selected';
        break;
      case 'busy':
        className += ' disabled';
        break;
      case 'pass':
      case 'driver':
        className += ' disabled no-seat';
        break;
      case 'exit':
        className += ' disabled exit-seat';
        break;
      default:
        className += ' disabled';
        break;
    }
    return className;
  };
  getNumber = () => {
    const seatNumber = parseInt(this.props.number, 10);
    return !isNaN(seatNumber) ? seatNumber : '';
  };
  render() {
    return /*#__PURE__*/React.createElement("div", {
      className: this.getClassName(this.props.type)
    }, SEAT_TYPES.includes(this.props.type) && /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement("input", {
      id: this.props.id,
      type: "checkbox",
      checked: this.props.isSelected,
      readOnly: true
    }), /*#__PURE__*/React.createElement("label", {
      onClick: this.onClick,
      htmlFor: this.props.id
    }, /*#__PURE__*/React.createElement("span", null, this.getNumber()), /*#__PURE__*/React.createElement("i", {
      className: "icon icon-seat-select"
    }))));
  }
}